import generatePromptPayPayload from 'promptpay-qr'

const sanitizePromptPayTarget = (value: string): string => value.replace(/\D/g, '').trim()

export const buildPromptPayQrValue = (target: string, amount?: number | string | null): string | null => {
  const sanitizedTarget = sanitizePromptPayTarget(target)
  if (!sanitizedTarget) return null

  const numericAmount =
    typeof amount === 'number'
      ? amount
      : typeof amount === 'string'
        ? Number(amount)
        : NaN

  if (Number.isFinite(numericAmount) && numericAmount > 0) {
    return generatePromptPayPayload(sanitizedTarget, { amount: numericAmount })
  }

  return generatePromptPayPayload(sanitizedTarget, {})
}
